import { StarRatingAboveTooltipBelowLayout } from '@ria-client/tw-shared-ui';
import { ProductCardRedesignCtaButton } from './cta-button';
import { CtaImage } from './cta-image';
import { CtaName } from './cta-name';
import type { ProductSectionProps } from './product-section';

export function MobileProductSection({
  cta,
  ctaAnalytics,
  displayName,
  image,
  starRating,
  starRatingTooltip,
  reviewLink,
  federallyInsuredAnnotation,
}: ProductSectionProps) {
  return (
    <div className="flex flex-col gap-3.5">
      <CtaName cta={cta} ctaAnalytics={ctaAnalytics} displayName={displayName} />
      <div className="flex items-center justify-around gap-3">
        <CtaImage cta={cta} ctaAnalytics={ctaAnalytics} displayName={displayName} image={image} />
        <StarRatingAboveTooltipBelowLayout
          reviewLink={reviewLink}
          starRating={starRating}
          starRatingTooltip={starRatingTooltip}
        />
      </div>
      <ProductCardRedesignCtaButton
        cta={cta}
        ctaAnalytics={ctaAnalytics}
        federallyInsuredAnnotation={federallyInsuredAnnotation}
      />
    </div>
  );
}
